// Angular
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

// Extensions
import { ToastrService } from 'ngx-toastr';

// Models
import * as models from 'app/http/models/index';

// RxJS
import { Subject } from 'rxjs';

// Services
import * as service from 'app/center/service/index';

@Injectable({
  providedIn: 'root'
})
export class ResponseService {
 // Private
 private errorsSubject = new Subject<models.RequestModel.Error[]>();
 private ticketSubject = new Subject<string>();

 // Public
 public $errors = this.errorsSubject.asObservable();
 public $ticket = this.ticketSubject.asObservable();

 constructor(private _router: Router, private _toastrService: ToastrService, private _centerService: service.Center) {}

 manageErrors(error: any | HttpErrorResponse) {
   if (localStorage.getItem('debug') === 'true') {
     console.log(error?.message);
     console.log(error);
   }
   if (error instanceof HttpErrorResponse) {
     if (error.status === 400) {
       if (error.error.topcode === 0) {
         this._router.navigate(['/pages/miscellaneous/app-error']);
         this._toastrService.error('La estructura (JSON) de su solicitud no es válida.', 'Error en la solicitud 😔', {
           toastClass: 'toast ngx-toastr',
           closeButton: true,
           timeOut: 0,
         });
         return;
       } else if (error.error.hasOwnProperty('errors')) {
         if (!Array.isArray(error.error.errors) || error.error.errors.length < 1) {
           this.showErrors([
             {
               problem: 'El servidor no arrojo correctamente los errores',
               solution: 'Solicite la asistencia.',
               by: 'Servidor',
             },
           ]);
           return;
         } else {
           this.showErrors(error.error.errors);
           return;
         }
       } else if (error.error?.topcode === 'files-404') {
         this._toastrService.error('No has subido ningún archivo, por favor, súbelo.', 'Error en la carga de archivos 😔', {
           toastClass: 'toast ngx-toastr',
           closeButton: true,
           timeOut: 0,
         });
       } else {
         this._toastrService.error(
           'El administrador de errores no puede manejarlo. Requiere una solución específica.',
           'Error específico 🛠',
           { toastClass: 'toast ngx-toastr', closeButton: true, timeOut: 0 }
         );
         return;
       }
     } else if (error.status === 401 || error.status === 403) {
       return;
     } else if (error.status === 404) {
       if (error.error.topcode === -1 || error.error.topcode === 0) {
         this._router.navigate(['/pages/miscellaneous/server']);
         this._toastrService.error('Problema con los archivos básicos.', 'Error en la base de datos', {
           toastClass: 'toast ngx-toastr',
           closeButton: true,
           timeOut: 0,
         });
         return;
       } else if (error.error.topcode === 1) {
         this._centerService.cleanCurrentCenter();
         this._router.navigate(['/pages/app/centers']);
         return;
       } else if (error.error.topcode === 2) {
         this._toastrService.error('El proyecto no se encuentra activo.', '', {
           toastClass: 'toast ngx-toastr',
           closeButton: true,
           timeOut: 0,
         });
         this._centerService.cleanCurrentCenter();
         this._router.navigate(['/pages/app/centers']);
         return;
       } else if (error.error.topcode === 3) {
         this._toastrService.error('El proyecto no se encuentra en modo "OPCIONES".', '', {
           toastClass: 'toast ngx-toastr',
           closeButton: true,
           timeOut: 0,
         });
         return;
       } else if (error.error.topcode === 4) {
         this._toastrService.error('El proyecto no se encuentra en modo "REPORTES".', '', {
           toastClass: 'toast ngx-toastr',
           closeButton: true,
           timeOut: 0,
         });
         return;
       } else if (error.error.topcode === 404) {
         this._toastrService.error('La API solicitada no existe.', 'Error API', {
           toastClass: 'toast ngx-toastr',
           closeButton: true,
           timeOut: 0,
         });
         return;
       } else {
         this._toastrService.error(
           'El administrador de errores no puede manejarlo. Requiere una solución específica.',
           'Error HTTP (404) 🛠',
           { toastClass: 'toast ngx-toastr', closeButton: true, timeOut: 0 }
         );
         return;
       }
     } else if (error.status === 429) {
       this._toastrService.error(
         'Lo sentimos 😔, pero nos ha enviado demasiadas solicitudes últimamente. Por favor, inténtelo de nuevo más tarde.',
         '¡Wow! Demasiadas solicitudes ⏱',
         { toastClass: 'toast ngx-toastr', closeButton: true }
       );
       return;
     } else if (error.status === 500) {
       if (error.error.topcode === 0) {
         this._router.navigate(['/pages/miscellaneous/maintenance']);
         return;
       } else if (typeof error.error.id === 'string') {
         this.showTicket(error.error.id);
         return;
       } else if (error.error.hasOwnProperty('errors')) {
         if (!Array.isArray(error.error.errors) || error.error.errors.length < 1) {
           this.showErrors([
             {
               problem: 'El servidor no arrojo correctamente los errores',
               solution: 'Solicite la asistencia.',
               by: 'Servidor',
             },
           ]);
           return;
         } else {
           this.showErrors(error.error.errors);
           return;
         }
       } else {
         this._router.navigate(['/pages/miscellaneous/server']);
         return;
       }
     } else if (error.status === 503) {
       if (error.error.topcode === 1 || error.error.topcode === 2) {
         this._router.navigate(['/pages/miscellaneous/maintenance']);
         return;
       } else {
         this._router.navigate(['/pages/miscellaneous/server']);
         return;
       }
     } else if (error.status === 505) {
       this._router.navigate(['/pages/miscellaneous/server']);
       return;
     } else {
       this._toastrService.error(
         'El administrador de errores no puede manejarlo. Comprueba tu conexión a Internet.',
         'Error HTTP (' + error.status + ') 🛠',
         { toastClass: 'toast ngx-toastr', closeButton: true, timeOut: 0 }
       );
       return;
     }
   } else {
     this._router.navigate(['/pages/miscellaneous/app-error']);
     return;
   }
 }

 private showErrors(ErrorsData: models.RequestModel.Error[]) {
   this.errorsSubject.next(ErrorsData);
 }

 private showTicket(ticket: string) {
   this.ticketSubject.next(ticket);
 }
}
